import { defineStore } from 'pinia'
import FingerprintJS from '@fingerprintjs/fingerprintjs'

const useStore = defineStore('default', {
  state: () => ({
    deviceId: ''
  }),
  actions: {
    /** FingerprintJS 是异步的，很多时候 useInitDefaultStore 没法比同步快，需要在用之前重复获取一边..
     * 比如 utils/request.ts、pages/download.vue
     * 有思路了再优化 */
    async setDeviceId(deviceId?: string) {
      if (deviceId) {
        this.deviceId = deviceId
        return
      }
      const fp = await FingerprintJS.load()
      const result = await fp.get()
      // pages/download.vue query 拿到的 deviceId 有可能在 await 期间赋值上了，防止覆盖
      this.deviceId = this.deviceId || result.visitorId
    }
  }
})

export default useStore

export function useInitDefaultStore() {
  const store = useStore()
  return store.setDeviceId()
}
